export enum PortalKeyDatesType {
    LEAD = 'Lead',
    OPENED = 'Opened',
    PRE_QUALIFICATION = 'Pre-Qualification',
    REGISTERED = 'Registered',
    PRE_PROCESSING = 'Pre-Processing',
    PROCESSING = 'Processing',
    DOCUMENT_CHECK_V2 = 'Document Check',
    DOCUMENT_CHECK = 'Loan Submitted',
    DOCUMENT_CHECK_FAILED_V2 = 'Document Check Failed',
    DOCUMENT_CHECK_FAILED = 'Submission Incomplete',
    LOAN_SUBMITTED_V2 = 'Submitted To UW',
    LOAN_SUBMITTED = 'Submitted To UW',
    PRE_UNDERWRITING = 'Pre-Underwriting',
    UNDERWRITING_V2 = 'In Underwriting',
    UNDERWRITING = 'In UW Review',
    PRE_APPROVAL = 'Pre-Approval',
    APPROVED = 'Approved Date',
    CONDITION_REVIEW_V2 = 'Condition Review',
    CONDITION_REVIEW = 'Conditions Submitted',
    FINAL_UNDERWRITING_V2 = 'Final Underwriting',
    FINAL_UNDERWRITING = 'Re-submitted to UW',
    PRE_DOC_QC_V2 = 'Pre-Doc QC',
    PRE_DOC_QC = 'Submitted for CTC',
    CLEAR_TO_CLOSE = 'Clear to Close',
    DOCS_ORDERED = 'Docs Ordered',
    DOC_DRAWN = 'Docs Drawn',
    DOCS_OUT = 'Docs Out',
    DOCS_BACK_V2 = 'Docs Back',
    DOCS_BACK = 'Docs Back/Funding Review',
    FUNDING_CONDITIONS = 'Funding Conditions',
    FUNDED = 'Funded',
    RECORDED = 'Recorded',
    FINAL_DOCS = 'Final Docs',
    CLOSED = 'Closed',
    SUBMITTED_FOR_PURCHASE_REVIEW = 'Submitted for Purchase Review',
    IN_PURCHASE_REVIEW = 'In Purchase Review',
    PRE_PURCHASE_CONDITIONS = 'Pre-Purchase Conditions',
    SUBMITTED_FOR_FINAL_PURCHASE = 'Submitted for Final Purchase',
    IN_FINAL_PURCHASE_REVIEW = 'In Final Purchase Review',
    CLEAR_TO_PURCHASE = 'Clear to Purchase',
    PURCHASED = 'Purchased',
    READY_FOR_SALE = 'Ready for Sale',
    SHIPPED_TO_INVESTOR = 'Shipped to Investor',
    SUSPENDED_BY_INVESTOR = 'Suspended by Investor',
    ADDITIONAL_COND_SENT = 'Additional Conditions Sent',
    LOAN_PURCHASE = 'Loan Purchase',
    COUNTER_OFFER = 'Counter Offer',
    ON_HOLD = 'On Hold',
    CANCELED = 'Canceled',
    SUSPENDED = 'Suspended Date',
    REJECT = 'Rejected',
    WITHDRAWN = 'Withdrawn',
    ARCHIVED = 'Archived',
    QC_COMPLETION = 'QC Completion',
    INITIAL_LE_SENT = 'Initial LE Sent',
    LATEST_LE_SENT = 'Latest LE Sent',
    INITIAL_CD_SENT = 'Initial CD Sent',
    LATEST_CD_SENT = 'Latest CD Sent',
    // Add signed disclosure variants
    INITIAL_LE_SIGNED = 'Initial LE Signed',
    LATEST_LE_SIGNED = 'Latest LE Signed',
    INITIAL_CD_SIGNED = 'Initial CD Signed',
    LATEST_CD_SIGNED = 'Latest CD Signed',
    // Rate Lock Expiration
    RATE_LOCK_EXPIRATION = 'Rate Lock Expiration',
}